// Deterministic hashing + PRNG so worker visuals/movement are stable per id.

/**
 * Hash a string to an unsigned 32-bit integer seed.
 * Uses FNV-1a to produce a stable, non-negative seed for any string key.
 * @param {string} str
 * @returns {number} unsigned 32-bit integer
 */
export function hashStringToSeed(str) {
  let h = 2166136261 >>> 0;
  const s = String(str);
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/**
 * Returns a mulberry32 PRNG function seeded with the given 32-bit integer.
 * Each call to the returned function yields the next float in [0, 1).
 * @param {number} seed - unsigned 32-bit integer
 * @returns {() => number}
 */
export function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
